<template>
  <div v-if="isSuccessRegister">
    <h3 class="ts-auth-title fw-bold mb-3">{{ translations[13898] }}</h3>
    <p>
      {{ translations[13899] }}
    </p>
    <p>{{ translations[13932] }}
      <a class="fw-bolder" href="#" @click.prevent="reloadTab">
        {{ translations[13933] }}
      </a>
    </p>
  </div>
  <b-form ref="registerForm" v-else autocomplete="new-password" @keydown="handleKeydown">
    <b-alert :show="isErrorsRegister" variant="danger">
      <span v-if="isUsernameExist">{{ translations[1283] }}</span>
      <span v-if="isEmailExist">{{ translations[10870] }}</span>
      <span v-if="isPrivacyError">{{ translations[14435] }}</span>
    </b-alert>
    <b-alert :show="isErrorsRegisterPassword" variant="danger">
      {{ translations[240] }}
    </b-alert>
    <!-- Same sections as the applicant form (design: "Persönliche Daten" / "Ich bin damit einverstanden:") -->
    <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[1315] }}</h3>
    <div class="ts-register-fields d-flex flex-column gap-2">
      <b-form-group
        class="mb-0"
        id="input-company-1"
        label-for="company-username-register"
      >
        <b-form-input
          id="company-username-register"
          v-model="register.username"
          type="text"
          autocomplete="new-password"
          :placeholder="translations[11001]"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="mb-0"
        label-for="company-email-register"
      >
        <b-form-input
          id="company-email-register"
          v-model="register.email"
          type="email"
          autocomplete="new-password"
          :placeholder="translations[5549]"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="isCompanyField(typeField.visible, regField.firmname)" class="mb-0" id="input-group-3" label-for="company-firmname-register">
        <b-form-input
          id="company-firmname-register"
          v-model="register.firmname"
          type="text"
          :placeholder="translations[407]"
          :required="isCompanyField(typeField.mandatory, regField.firmname)"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="isCompanyField(typeField.visible, regField.firstname)" class="mb-0" id="input-group-3" label-for="company-firstname-register">
        <b-form-input
          id="company-firstname-register"
          v-model="register.firstname"
          type="text"
          :placeholder="translations[234]"
          :required="isCompanyField(typeField.mandatory, regField.firstname)"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="isCompanyField(typeField.visible, regField.lastname)" class="mb-0" id="input-group-4" label-for="company-lastname-register">
        <b-form-input
          id="company-lastname-register"
          v-model="register.lastname"
          type="text"
          :placeholder="translations[235]"
          :required="isCompanyField(typeField.mandatory, regField.lastname)"
        ></b-form-input>
      </b-form-group>
      <PasswordPattern
        id="company-password-register"
        v-model.trim="register.password"
        :placeholder="translations[10948]"
        :title-widget="translations[2521]"
      />
      <PasswordPattern
        id="company-password_repeat"
        v-model.trim="register.password_repeat"
        :placeholder="translations[236]"
        :title-widget="translations[2521]"
      />
    </div>
    <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15218] }}</h3>
    <b-form-group class="mb-1" label-for="privacy-checkbox">
      <b-form-checkbox id="privacy-checkbox" v-model="isPrivacyAccepted" name="check-button" plain>
        <p class="ts-register-consent small mb-0" ref="content" v-html="translations[15008]"></p>
      </b-form-checkbox>
    </b-form-group>
  </b-form>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { mixins } from 'vue-class-component';
import RegistrationFieldsMixin from '@/mixins/RegistrationFieldsMixin';
import { RegistrationField, TypeField } from '@/types/Login';
import PasswordPattern from '@/components/Widget/PasswordPattern.vue';

@Component({
  components: { PasswordPattern },
})
export default class RegisterCompanyForm extends mixins(RegistrationFieldsMixin) {
  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  // get isInputToSid() {
  //   return ['talentpool', 'edunet', 'kh'].includes(this.sid);
  // }
  //
  // get policyLink() {
  //   return this.lang === 'en'
  //     ? 'https://www.workinaustria.com/en/talenthub-terms-of-use/'
  //     : 'https://www.workinaustria.com/nutzungsbedingungen/';
  // }

  isPrivacyAccepted = false;

  get isErrorsRegister() {
    return this.isUsernameExist || this.isEmailExist || this.isPrivacyError;
  }

  isErrorsRegisterPassword = false;

  isSuccessRegister = false;

  isPrivacyError = false;

  @Watch('isPrivacyAccepted')
  handler(val: boolean) {
    if (val) this.isPrivacyError = false;
  }

  @Watch('register.password')
  handlerPassword(val: boolean) {
    if (val) this.isErrorsRegisterPassword = false;
  }

  @Watch('register.password_repeat')
  handlerPasswordRepeat(val: boolean) {
    if (val) this.isErrorsRegisterPassword = false;
  }

  isEmailExist = false;

  isUsernameExist = false;

  register = {
    username: '',
    password: '',
    password_repeat: '',
    email: '',
    sid: this.sid,
    lang: this.lang,
    firstname: '',
    lastname: '',
    firmname: '',
  } as any;

  reloadTab() {
    this.$bvModal.hide('register-modal');
    this.$bvModal.show('login-modal');
  }

  resetErrors() {
    this.isPrivacyError = false;
    this.isEmailExist = false;
    this.isUsernameExist = false;
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.$emit('submit');
    }
  }

  async onLogin() {
    try {
      const login = {
        username: this.register.username,
        password: this.register.password,
        sid: this.sid,
      };
      await UserModule.LoginCompany(login);
      await this.$router.push({
        name: 'Cabinet',
        query: { lang: this.lang },
      });
    } catch (error: any) {
      console.error(error);
    }
  }

  async onRegistration() {
    const form = this.$refs.registerForm as HTMLFormElement;
    if (!form.reportValidity()) {
      return;
    }
    const companyOptionalFields = [
      RegistrationField.firstname,
      RegistrationField.lastname,
      RegistrationField.firstname,
    ];

    companyOptionalFields.forEach((field) => {
      if (!this.isCompanyField(TypeField.visible, field)) {
        delete this.register[field];
      }
    });

    if (!this.isPrivacyAccepted) {
      this.isPrivacyError = true;
      return;
    }

    if (this.register.password !== this.register.password_repeat) {
      this.isErrorsRegisterPassword = true;
      return;
    }

    this.resetErrors();
    // this.isErrorsRegisterPassword = false;
    try {
      await UserModule.RegisterCompany(this.register).then((response: any) => {
        if (response.autolog) {
          this.onLogin();
        } else {
          this.isSuccessRegister = true;
          this.$emit('registered');
        }
      });
    } catch (error: any) {
      if (error.response.data.message === 'email already exists') this.isEmailExist = true;
      if (error.response.data.message === 'username already exists') this.isUsernameExist = true;
      this.$bvToast.toast(error.response.data.message, {
        title: 'Warning',
        variant: 'warning',
        autoHideDelay: 5000,
        solid: true,
      });
    }
  }

  @Watch('translations', { deep: true })
  handlerTranslation(newVal: any[]) {
    if (newVal && newVal[15008]) {
      this.$nextTick(() => {
        this.initializeModal();
      });
    }
  }

  initializeModal() {
    const termsLink = (this.$refs as any).content.querySelector('.terms-link');
    if (termsLink) {
      termsLink.addEventListener('click', (event: any) => {
        event.preventDefault();
        this.$bvModal.show('terms-modal');
      });
    }
  }

  mounted() {
    this.initializeModal();
  }
}
</script>
